import * as moment from 'moment'
import * as React from 'react'
import { SERVICE_LIST_TYPE } from '../../../../state/constants'
import { IMap, IMembershipObject, IRiderObject, IServiceObject, IStateMetadata } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import RiderBottomBar from '../CreateRiderBottomBar'
import MembershipListItem from './MembershipListItem'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface IMembershipPaneProps {
  orgId: string
  metadata: IStateMetadata
  rider: IRiderObject
  currentStep: number
  onCompleteStep: (step: number) => void
  showMessage: (error: string, isError: boolean) => void
  services: IMap<IServiceObject>
  getServiceList: (type: string, orgId: string) => void
  saveMembership: (rider: IRiderObject, memberships: IMembershipObject[]) => void
}

export interface IMembershipSpecialObject extends IMembershipObject {
  selected: boolean
}

interface IMembershipPaneState {
  isSaved: boolean
  isSaving: boolean
  selected: IMembershipSpecialObject[]
}

class MembershipPane extends React.Component<IMembershipPaneProps, IMembershipPaneState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isSaved: false,
      isSaving: false,
      selected: []
    }
    this.props.onCompleteStep(this.props.currentStep)
  }

  public componentDidMount() {
    this.props.getServiceList(SERVICE_LIST_TYPE.ACTIVE, this.props.orgId)
    if (this.props.services && Object.keys(this.props.services).length > 0) {
      this.setPropsToState()
    }
  }

  public componentDidUpdate(prevProps: IMembershipPaneProps) {
    if (Object.keys(this.props.services).length > 0 && Object.keys(prevProps.services).length === 0) {
      this.setPropsToState()
    }
    if (prevProps.metadata !== this.props.metadata) {
      const { processingError, processingSuccess } = this.props.metadata
      if (processingError) {
        this.setState({ isSaving: false, isSaved: false })
      }
      if (processingSuccess) {
        this.setState({ isSaving: false, isSaved: true })
      }
    }
  }

  public render() {
    const { services } = this.props
    const bodyStyle: any = {
      pointerEvents: this.state.isSaving ? 'none' : 'auto',
      opacity: this.state.isSaving ? 0.4 : 1.0
    }

    return (
      <section>
        <FloatingForm fullHeight={true}>
          <div className='form-modal-section main-section'>
            <div>
              {Object.values(services).map((item: IServiceObject) => (
                <div className={`MembershipItem-${item.id}`} key={`tmli-${item.id}`}>
                  <MembershipListItem onUpdate={this.onUpdateMembership} service={item} />
                </div>
              ))}
            </div>
          </div>
        </FloatingForm>
        <RiderBottomBar
          isSaved={this.state.isSaved}
          isSaving={this.state.isSaving}
          nextStepPath={'/riders/create/wallet'}
          previousStepPath={'/riders/create/location'}
          onSave={this.onSave}
        />
      </section>
    )
  }

  private onUpdateMembership = (membership: IMembershipSpecialObject) => {
    const selected = this.state.selected.map((it: any) => {
      if (it.serviceId === membership.serviceId) {
        return membership
      }
      return it
    })
    this.setState({
      selected,
      isSaved: false
    })
  }

  private onSave = () => {
    for (const membership of this.state.selected) {
      if (membership.selected && membership.isLimitedByRecurringMonths && membership.recurringMonths.length === 0) {
        this.props.showMessage(UIMessages.rider.validation.membershipRecurringMonthsMinLength, true)
        return
      }
    }

    const selected: IMembershipObject[] = this.state.selected.filter((it: any) => it.selected)

    if (selected.length < 1) {
      this.props.showMessage(UIMessages.rider.validation.needsOneMembersip, true)
      return
    }

    this.setState({ isSaving: true })
    this.props.saveMembership(this.props.rider, selected)
  }

  private setPropsToState = () => {
    const selected: IMembershipSpecialObject[] = Object.values(this.props.services).map((it: IServiceObject) => {
      return {
        service: it,
        serviceId: it.id,
        type: 'PERMANENT',
        isLimitedByDate: false,
        requestedAt: new Date(),
        beginsAt: moment(),
        expiresAt: moment().add(1, 'year'),
        isLimitedByRecurringMonths: false,
        recurringMonths: [],
        isLimitedByNumberOfRides: false,
        ridesRangeType: 'Week',
        ridesNum: 1,
        selected: false,
        isSuspended: false,
        suspensionUntil: new Date()
      }
    })
    this.setState({ selected })
  }
}

export default MembershipPane



// WEBPACK FOOTER //
// ./src/components/riders/createrider/membership/MembershipPane.tsx